import { Check, CheckIcon, X, XIcon } from "lucide-react";
import { DotList } from "./BulletedList";
import { WelcomeH3 } from "./SectionShell";
import { Colors } from "../../../styles/theme";

export function WelcomeBeforeAfter() {
  return (
    <div className="mt-6">
      <WelcomeH3>Veja como o atendimento mudou</WelcomeH3>

      <div className="mt-2 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div className="rounded-[6px] border border-slate-300 bg-white p-4">
          <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
            <span className="grid h-6 w-6 place-items-center rounded-full bg-red-50 text-red-700">
              <X className="h-[15px] w-[15px]" />
            </span>
            <h3 className="text-xl font-bold" style={{ color: Colors.AZUL_GOV_DARK }}>Antes</h3>
          </div>
          <DotList
            items={[
              "Você precisa buscar informação",
              "Precisava acessar vários sistemas",
              "Pode perder prazos",
            ]}
            icon={<XIcon className="h-3 w-3 text-[#EF4444]" />}
          />
        </div>

        <div className="rounded-[6px] border border-slate-300 bg-white p-4">
          <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
            <span className="grid h-6 w-6 place-items-center rounded-full bg-emerald-50 text-emerald-700">
              <Check className="h-[15px] w-[15px]" />
            </span>
            <h3 className="text-xl font-bold" style={{ color: Colors.AZUL_GOV_DARK }}>Agora</h3>
          </div>  
          <DotList
            items={[
              "Você recebe automaticamente",
              "Recebe no canal preferidoo",
              "Recebe lembretes no momento certo",
            ]}
            icon={<CheckIcon className="h-3 w-3 text-[#10B981]" />}
          />
        </div>
      </div>
    </div>
  );
}
